import {Unsubscribe} from 'redux';

import {NotYetFetchedException} from 'connect/DefensiveGet';
import {Entry} from 'notebook/entries/backbone/filestate/Entry';
import {getStore} from 'redux-stores/Store';
import memoizeLastCall from 'util/memoizeLastCall';

import {
  getRelevantStateObjects,
  getResultStatusTabTables,
  RelevantStateObjects,
} from './getResultStatusTabTables';

interface ConstructorOptions {
  entryFile: Entry;
  addResultStatusTab: () => void;
}

type ShouldRenderFunc = (entryFile: Entry, relevantStateObjects: RelevantStateObjects) => boolean;

export default class ResultStatusTabRenderer {
  entryFile: Entry;
  addResultStatusTab: () => void;
  memoizedShouldRender: ShouldRenderFunc;

  constructor(options: ConstructorOptions) {
    this.entryFile = options.entryFile;
    this.addResultStatusTab = options.addResultStatusTab;
    this.memoizedShouldRender = this.createMemoizedShouldRenderFunction();
  }

  createMemoizedShouldRenderFunction(): ShouldRenderFunc {
    return memoizeLastCall(
      (entryFile: Entry, relevantStateObjects: RelevantStateObjects) =>
        getResultStatusTabTables(entryFile, relevantStateObjects).length > 0,
      {useDeepEquality: true}
    );
  }

  init(): Unsubscribe | null {
    if (!this.tryRender()) {
      return getStore().subscribe(this.reduxUpdateCallback.bind(this));
    }
    return null;
  }

  reduxUpdateCallback(): void {
    this.tryRender();
  }

  tryRender(): boolean {
    try {
      if (this.memoizedShouldRender(this.entryFile, getRelevantStateObjects(getStore().getState()))) {
        this.addResultStatusTab();
        return true;
      }
      return false;
    } catch (e) {
      if (e instanceof NotYetFetchedException) {
        return false;
      } else {
        throw e;
      }
    }
  }
}
